import React, { useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { Page, useStyles } from 'pages/WelcomePage';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'NavigationProvider';
import useDoctorNavigationPages from './doctor-dashboard/navigationPages';

const DoctorKitRegistrationDashboardAll = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { navigateToPage } = useNavigation();
  const navigationPages = useDoctorNavigationPages();

  const title = useMemo(() => {
    return navigationPages.find((page) => {
      return 'register-and-view-folder' === page.id;
    })?.items?.find((page) => {
      return 'registerNewKitDoctor' === page.id;
    })?.title;
  }, [ navigationPages ]);

  const specificPages = useMemo(() => {
    return navigationPages.find((page) => {
      return 'register-and-view-folder' === page.id;
    })?.items?.find((page) => {
      return 'registerNewKitDoctor' === page.id;
    })?.items?.filter((page) => {
      return true !== page.isMenuHidden;
    });
  }, [ navigationPages ]);

  return (
    <div style={ {
      background: '#F7F7F7',
      minHeight: '450px',
      padding: '10px 10px 30px 10px',
    } }
    >
      <Grid
        container
        spacing={ 2 }
      >
        <Grid item xs={ 12 }>
          <div className={ classes.titleCta }>
            <Typography variant='h6' color='textPrimary'>
              {t(title)}
            </Typography>
          </div>
        </Grid>
        {
          specificPages.map((page) => {
            const href = `/?pid=${ page.id }`;

            return (
              <Grid
                className={ classes.pageGridItem }
                key={ href }
                item
                xs={ 12 }
                md={ 6 }
                lg={ 6 }
                xl={ 4 }
                component={ true === page.isDisabled ? 'div' : 'a' }
                href={ href }
                onClick={
                  (e) => {
                    e.preventDefault();
                    if (true !== page.isDisabled) {
                      navigateToPage({ pageId: page.id });
                    }
                  }
                }
              >
                <Page pageInfo={ page } />
              </Grid>
            );
          })
        }
      </Grid>
    </div>
  );
};

export default DoctorKitRegistrationDashboardAll;
